import ProductCard from '@ulta/components/ProductCard/ProductCard';

export default ProductCard;